import { FC, PropsWithChildren } from "react";

const Footer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      id="footer"
      // Removed the max-h-[46px] class to allow for dynamic height.
      className="rounded-b-[12px]"
      // This style can be put in as a tailwind class if we prefer that approach.
      style={{
        background:
          "linear-gradient(360deg, #FFFFFF 48.98%, hsl(var(--gray-100)) 161.22%)",
      }}
    >
      {children}
    </div>
  );
};

export default Footer;
